import React, { useState, useEffect } from 'react'
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import YesNoPopup from '../common/components/YesNoPopup';
import Error from  '../common/components/ErrorMessage'
import Success from  '../common/components/SuccessMessage'
import Select from 'react-select';
import {GET_GENERAL_DATA_FUNCTION,UPDATE_GENERAL_INFO_FUNCTION} from '../common/ResourcePaths';
import AuthData from '../common/AuthData';
import Fetch from '../services/fetchService';
import Post from '../services/postService';

function Settings(){

    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [successTimer, setSuccessTimer] = useState(5);
    const [companyName, setCompanyName] = useState('');
    const [header, setHeader] = useState('');
    const [email, setEmail] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [modified, setModified] = useState(false);
    const [country, setCountry] = useState('');

    // Validation states
    const [companyNameError, setCompanyNameError] = useState('');
    const [headerError, setHeaderError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [currencyError, setCurrencyError] = useState(''); // Add this with other validation states
    const [countryError, setCountryError] = useState('');

    const currencyOptions = [
        { value: '', label: 'Select currency...' }, // Add empty value option
        { value: '$', label: 'Dollar ($)' },
        { value: '€', label: 'Euro (€)' },
        { value: '₱', label: 'Philippine Peso (₱)' },
    ];

    const countryOptions = [
        { value: '', label: 'Select country...' },
        { value: 'USA', label: 'USA' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Philippines', label: 'Philippines' },
    ];

    useEffect(() => {
        const get = async () => {
            try {
                setLoader(true);
                const authData = AuthData.getAuthData();
                const url = `${authData.appFunctionUrl}${GET_GENERAL_DATA_FUNCTION}?code=${authData.azureFunctionKey}`;
                const response = await Fetch(url, authData.clientId);
                setCompanyName(response.clientName || '');
                setHeader(response.header || '');
                setEmail(response.email || '');
                setCurrencySymbol(response.currencySymbol || '');
                setCountry(response.country || '');
                
                // Store country in localStorage
                if (response.country) {
                    localStorage.setItem('country', response.country);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoader(false);
            }
        };

        get();
    }, []);

    // Validation helpers
    const validateCompanyName = (value) => {
        if (!value.trim()) return 'Company name is required.';
        if (value.length > 50) return 'Company name must be less than 50 characters.';
        return '';
    };

    const validateHeader = (value) => {
        if (!value.trim()) return 'Header is required.';
        if (value.length > 100) return 'Header must be less than 100 characters.';
        return '';
    };

    const validateEmail = (value) => {
        if (!value.trim()) return 'Email is required.';
        if (value.length > 100) return 'Email must be less than 100 characters.';
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Please enter a valid email address.';
        return '';
    };

    const validateCurrency = (value) => {
        if (!value) return 'Currency symbol must be selected.';
        return '';
    };

    const validateCountry = (value) => {
        if (!value) return 'Country must be selected.';
        return '';
    };

    // Handlers
    const handleCompanyNameChange = (e) => {
        const value = e.target.value;
        setCompanyName(value);
        setModified(true);
        const error = validateCompanyName(value);
        setCompanyNameError(error);
    }

    const handleHeaderChange = (e) => {
        const value = e.target.value;
        setHeader(value);
        setModified(true);
        const error = validateHeader(value);
        setHeaderError(error);
    }

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setModified(true);
        const error = validateEmail(value);
        setEmailError(error);
    }

    const handleCurrencyChange = (option) => {
        const value = option ? option.value : '';
        setCurrencySymbol(value);
        setModified(true);
        const error = validateCurrency(value);
        setCurrencyError(error);
    }

    const handleCountryChange = (option) => {
        const value = option ? option.value : '';
        setCountry(value);
        setModified(true);
        const error = validateCountry(value);
        setCountryError(error);
    };

    const saveHandler = async (e) => {
        e.preventDefault();

       
        setLoader(true);
        setError(null);
        setSuccess(null);

        try {
            const authData = AuthData.getAuthData();
            const url = `${authData.appFunctionUrl}${UPDATE_GENERAL_INFO_FUNCTION}?code=${authData.azureFunctionKey}`;
            const payload = {
                clientName: companyName,
                header: header,
                email: email,
                currencySymbol: currencySymbol,
                country: country
            };
            const response = await Post(url, authData.clientId, payload);

            setCompanyName(response.clientName || '');
            setHeader(response.header || '');
            setEmail(response.email || '');
            setCurrencySymbol(response.currencySymbol || '');
            setCountry(response.country || '');
            
            // Store country in localStorage
            if (response.country) {
                localStorage.setItem('country', response.country);
            }

            setSuccess(true);
            setModified(false);
            setSuccessTimer(10);
            const timerInterval = setInterval(() => {
                setSuccessTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerInterval);
                        setSuccess(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (err) {
            setError('An error occurred while saving.');
        } finally {
            setLoader(false);
            setModified(false);
        }
    }

    const handleYes = () => {
        setModified(false);
        setCompanyName('');
        setHeader('');
        setEmail('');
        setCurrencySymbol('');
        setCountry('');
        setCompanyNameError('');
        setHeaderError('');
        setEmailError('');
        setShowPopup(false);
        setError(null);
        setSuccess(null);
    }
    const handleNo = () => { setShowPopup(false); }

    return (
        <div className="container" style={{ position: 'relative' }}>
            {loader && <RelativeSvgLoader />}
            <div className="form-wrapper" style={{ opacity: loader ? 0.3 : 1 }}>
                {/* Show combined error box above all fields */}
                {(companyNameError || headerError || emailError || currencyError || countryError) && (
                    <Error message={
                        [error, companyNameError, headerError, emailError, currencyError, countryError]
                            .filter(Boolean)
                            .join(' ')
                    } />
                )}
                {success && <Success message={`Data saved successfully! (${successTimer}s)`} />}
                 <form onSubmit={saveHandler}>    
                    <div className="form-grid">
                        <label htmlFor="companyName" className="form-label">Company name:</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={companyName}
                            onChange={handleCompanyNameChange}
                            className="input-field"
                        />
                        <label htmlFor="address" className="form-label">Header:</label>
                        <input 
                            type="text" 
                            id="header" 
                            name="header" 
                            value={header}
                            onChange={handleHeaderChange}
                            className="input-field"
                        />
                        <label htmlFor="email" className="form-label">Email:</label>
                        <input 
                            type="email" 
                            id="email" 
                            name="email" 
                            value={email}
                            onChange={handleEmailChange}
                            className="input-field"
                        />
                        <label htmlFor="currencySymbol" className="form-label">Currency Symbol:</label>
                        <Select
                            id="currencySymbol"
                            name="currencySymbol"
                            options={currencyOptions}
                            value={currencyOptions.find(opt => opt.value === currencySymbol)}
                            onChange={handleCurrencyChange}
                            className="input-field"
                            placeholder="Select currency"
                            isSearchable={false}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    width: '40%',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    boxShadow: state.isFocused || state.isHovered
                                        ? '0 0 6px 2px rgba(0, 0, 0, 0.15)'
                                        : 'none',
                                    borderColor: state.isFocused
                                        ? '#2684FF'
                                        : provided.borderColor,
                                    '&:hover': {
                                        boxShadow: '0 0 6px 2px rgba(0, 0, 0, 0.15)',
                                    },
                                }),
                            }}
                        />
                        <label htmlFor="country" className="form-label">Country:</label>
                        <Select
                            id="country"
                            name="country"
                            options={countryOptions}
                            value={countryOptions.find(opt => opt.value === country)}
                            onChange={handleCountryChange}
                            className="input-field"
                            placeholder="Select country"
                            isSearchable={false}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    width: '40%',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    boxShadow: state.isFocused || state.isHovered
                                        ? '0 0 6px 2px rgba(0, 0, 0, 0.15)'
                                        : 'none',
                                    borderColor: state.isFocused
                                        ? '#2684FF'
                                        : provided.borderColor,
                                    '&:hover': {
                                        boxShadow: '0 0 6px 2px rgba(0, 0, 0, 0.15)',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className='form-footer'>
                            <button
                                type="submit"
                                disabled={
                                    !modified ||
                                    !!companyNameError ||
                                    !!headerError ||
                                    !!emailError ||
                                    !!currencyError ||
                                    !!countryError ||
                                    !companyName.trim() ||
                                    !header.trim() ||
                                    !email.trim() ||
                                    !currencySymbol ||
                                    !country
                                }
                                className="submit-button"
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                className='clear-data-button'
                                style={{ marginLeft: '10px' }}
                                onClick={() => setShowPopup(true)}
                            >
                                Reset
                            </button>
                    </div>
                 </form>
            </div>
             {showPopup && (
               <YesNoPopup 
                handleYes={handleYes} 
                handleNo={handleNo}/>
            )}
        </div>
    );
}

export default Settings;